export default __webpack_public_path__ + "static/stanzen-sol-ba3ae6505c07d7b12227c86be1a886b8.png";